/**
 * Extracts unique filters from an array of links, removes falsy values, and sorts them alphabetically
 * @param {Array} links - Array of link objects that may contain a filters property
 * @returns {Array} Array of unique, sorted filter strings
 */
export const getAvailableFilters = (links) => {
  const flatFilters = links.flatMap((link) => link.filters);
  const filters = new Set(flatFilters);

  return Array.from(filters).filter(Boolean).sort();
};
